import React from 'react'

const Footer = () => {
  return (
    <>
    <section className='scroll-main'>
        <div className="scroll-left d-flex align-items-center py-2">
          <div className='mrq-text'>Blockchain Developers</div><div className='dash'></div>
          <div className='mrq-text'>Web Developers</div><div className='dash'></div>
          <div className='mrq-text'>Content Planners</div><div className='dash'></div>
          <div className='mrq-text'>Copywriters</div><div className='dash'></div>
          <div className='mrq-text'>UX/UI Designers</div><div className='dash'></div>
          <div className='mrq-text'>Videographers</div><div className='dash'></div>
          <div className='mrq-text'>Web Developers</div><div className='dash'></div>
        </div>
        <div className="gap"></div>
        <div className="scroll-right d-flex align-items-center py-1">
          <div className='mrq-text'>Blockchain Developers</div><div className='dash'></div>
          <div className='mrq-text'>Web Developers</div><div className='dash'></div>
          <div className='mrq-text'>Content Planners</div><div className='dash'></div>
          <div className='mrq-text'>Copywriters</div><div className='dash'></div>
          <div className='mrq-text'>UX/UI Designers</div><div className='dash'></div>
          <div className='mrq-text'>Videographers</div><div className='dash'></div>
          <div className='mrq-text'>Developers</div><div className='dash'></div>
        </div>
      </section>
      <section className='py-2 footer'>
        <div className="container">
            <div className="row text-center">
                <p className='text-light mt-3'>@Copyright-2022. All rights reserved.</p>
            </div>
        </div>
      </section>

    </>
  )
}

export default Footer
